import React, {useEffect, useState} from 'react';
import {Select} from "antd";


import {EntitlementsService} from "services";
import {Entitlement} from "types";

// interface EntitlementsSelectProps { props?: any }

const EntitlementsSelect: React.FC<any> = (props: any) => {
    const [data, setData] = useState<Entitlement[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = () => {
        setLoading(true)
        EntitlementsService.getAllEntitlements()
            .then(res => {
                let response = res?.data?.revenueCatEntitlements || []
                response = response?.map((item: Entitlement) => ({
                    key: `entitlement-${item?.id}`,
                    ...item
                }))
                if (response) {
                    setData((response))
                }
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }
    const options = data?.map((item: Entitlement) => ({label: `${item.displayName} (${item.lookupKey})`, value: item.lookupKey}))
    return <>
        <Select loading={loading} options={options} allowClear {...props}/>
    </>
}

export default EntitlementsSelect